import { render, staticRenderFns } from "./EmbedDesainWebsite.vue?vue&type=template&id=f2214816&scoped=true&"
import script from "./EmbedDesainWebsite.vue?vue&type=script&lang=js&"
export * from "./EmbedDesainWebsite.vue?vue&type=script&lang=js&"
import style0 from "./EmbedDesainWebsite.vue?vue&type=style&index=0&id=f2214816&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2214816",
  null
  
)

export default component.exports